module.exports = __webpack_public_path__ + "img/peek.351c9ce3.png";